import type ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import { type EditorModel } from '@/lib/types';

const getDefaultModel = (
  models: Record<number, EditorModel> | null,
  modelType: ModelType,
): EditorModel | null => {
  if (models === null) {
    return null;
  }

  const modelsForType = Object.values(models).filter(
    model => model.type === modelType,
  );

  for (const model of modelsForType) {
    if (model.isDefault) {
      return model;
    }
  }

  return null;
};

export default getDefaultModel;
